// extracted by mini-css-extract-plugin
export var description = "FullWidthImage-module--description--7KEgn";
export var image = "FullWidthImage-module--image--vEEE1";